import {CodePipeline,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {Stack} from '@mantine/core';


export const Profile = ({record}: { record: CodePipeline }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'ARN',
            value: record.arn || 'n/a',
            span: 12,
        }, {
            label: 'Version',
            value: record.version?.toString() || 'n/a',
            span: 12,
        }, {
            label: 'CloudFormation Stack',
            value: record.cloudFormationStackName || 'n/a',
            span: 12,
        }, {
            label: 'Last Execution Status',
            value: record.lastExecutionStatus || 'n/a',
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Last Execution Time',
            value: record.lastExecutionTime as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>

            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
